import createEventHub from '~/helpers/event_hub_factory';

export default createEventHub();
